'use client'

import Link from 'next/link'
import { useTranslations } from 'next-intl'

export const AHeaderHamburgerBelowCard = () => {
	const t = useTranslations('layout.header.hamburger.showMore')

	return (
		<div className='header-hamburger-below-card'>
			<div className='header-hamburger-below-card__block'>
				<p>
					<b>{t('content.address.label')}:</b>
				</p>
				<p>{t('content.address.name')}</p>
				<Link
					href={t('content.address.href')}
					title={t('content.address.street')}
					target='_blank'
					prefetch={false}
				>
					{t('content.address.street')}
				</Link>
				<p>
					{t('content.clientCenter.emailLabel')}{' '}
					<Link
						href={t('content.clientCenter.emailHref')}
						title={t('content.clientCenter.email')}
						prefetch={false}
					>
						{t('content.clientCenter.email')}
					</Link>
				</p>
			</div>

			<div className='header-hamburger-below-card__block'>
				<p>
					<b>{t('content.openingHours.label')}:</b>
				</p>
				<p>{t('content.openingHours.weekdays')}</p>
			</div>
		</div>
	)
}
